import type { Meta, StoryObj } from "@storybook/react";
import React from "react";
import { Text } from "react-native";

import { CaseComponent, SwitchComponent } from "../../components/SwitchCaseComponent";
import VStack from "../../ui_atoms/VStack";
import Button from "../../components/Button";
import HStack from "../../ui_atoms/HStack";
import Gap from "../../ui_atoms/Gap";

const FailHere = () => {
    throw new Error("This is a failure");
};

const StoryComponent = () => {
    const [select, setSelect] = React.useState(1);

    return (
        <VStack h={1} gap={1}>
            <HStack>
                <Button label="One" onPress={() => setSelect(1)} />
                <Gap gap={1} />
                <Button label="Two" onPress={() => setSelect(2)} />
            </HStack>
            <Text>Selected: {select}</Text>
            <VStack style={{ padding: 10, borderWidth: 1, borderColor: "black" }}>
                <SwitchComponent condition={select}>
                    <CaseComponent value={1}>
                        <Text>This is one</Text>
                    </CaseComponent>
                    <CaseComponent value={2}>
                        <Text>This is two A</Text>
                    </CaseComponent>
                    <CaseComponent value={2}>
                        <Text>This is two B</Text>
                    </CaseComponent>
                    <CaseComponent value={"never-displayed"}>
                        <FailHere />
                    </CaseComponent>
                </SwitchComponent>
            </VStack>
        </VStack>
    );
};

const meta = {
    title: "Components/SwitchCase",
    component: StoryComponent,
    argTypes: {
        profileType: {},
    },
    args: {},
    decorators: [(StoryFn) => <StoryFn />],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
